import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../.services/settings.service';
import { ConnectionService } from '../.services/connection.service';

 
 
  declare var getScreenConstraints:any;
  declare var getMediaElement:any;



@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})



export class VideoComponent implements OnInit {

  connection: ConnectionService;
  settings: SettingsService;
  videoStreams: Array<any> = [];
  screenshareOpen: boolean;
  screenshareOpenId: string;
  numberOfWindows: number;
  audioOnly: boolean; 
  screensharePluginURL: string = "https://chrome.google.com/webstore/detail/screen-capturing/ajhifddimkapgcifgcodmmfdlknahffk";





  checkIsScreen = (stream) => {
      if(stream.isScreen === true) {
          // width = connection.videosContainer.clientWidth - 20;
      }
  }

  checkAlreadyExists = (streamId) => {
      if(document.getElementById(streamId)) {
        var existing = document.getElementById(streamId);
        existing.parentNode.removeChild(existing);
    }
  }

  updateVideoStreams = () => {	
    let containers = document.getElementsByClassName('MVC-video');
   
    for(let i = 0; i < this.videoStreams.length; i++) {
        if(i <= this.numberOfWindows){
        containers[i].appendChild(this.videoStreams[i].element)
        this.videoStreams[i].element.media.play()
        }
    }		
  }

  addVideo = (event, mediaElement) => {
	this.videoStreams.push({
        userId: event.userid,//this.connection.connection.userId,
        streamId: event.streamid,
        element: mediaElement
    });

    this.updateVideoStreams();
 
  }

  removeVideo = (streamid) => {
      
    var mediaElement = document.getElementById(streamid);
    let find = this.videoStreams.findIndex((x) =>{
      return x.streamId === streamid;
    });

    if(find > -1) { 
        this.videoStreams.splice(find, 1);
        if(mediaElement) {
            mediaElement.parentNode.parentNode.removeChild(mediaElement.parentNode);
            //when three elements or more, the third video is getting overlayed on the second video.
            
        }
        
        this.updateVideoStreams();
        
    }

/*
    if(mediaElement) {
        mediaElement.parentNode.parentNode.removeChild(mediaElement.parentNode);
        // mediaElement.parentNode.removeChild(mediaElement);
        
    }


*/
    
  }

  addUserToUsersList = (id, stream) => {
      this.connection.addUser(id, stream);
  }

  removeUserFromUserList = (streamId) => {
      this.connection.removeUser(streamId);
  }


  checkIsLocal = (event) => {
    if(event.type === "local") { //&& not screenshare
        this.settings.setUserId(event.userid);
        this.settings.setStreamId(event.streamid); //Will want to make sure this is not a SCREENSHARE id, so the user doesn't lose reference to their actual video stream.
        let found = this.connection.users.find((x) => {
        return x.streamId === event.streamid;
        });

        if(found) {
            found.username = this.settings.getUsername();
            return(true);
        }
    }
  }


  muteSelf = (track) => {
    this.connection.connection.attachStreams.forEach((stream) => {
        if (stream.type === "local") {
            if(track === "audio") {
                stream.mute('audio');
            } else {
                stream.mute('video');
            }
        }
           
    });
  }

  checkSetup = (event) => {
    let isLocal = this.checkIsLocal(event);
    let isHost = this.connection.connection.isInitiator;
    let audioOn = this.settings.connectionConstraints.audio.value;
    let videoOn = this.settings.connectionConstraints.video.value;
    let hostId =this.connection.connection.sessionid;
    


    if(isLocal && isHost && !videoOn) { //&& audio only            <<<------------------<<<
        let tracks = event.stream.getVideoTracks();

        event.stream.mute('video');
        

        
        setTimeout(()=>{
            for(let track of tracks) {
                event.stream.removeTrack(track);
            }
            
        },500)

        event.stream.mute('video');
    }

    if(isLocal && isHost && !audioOn) { //video only                       <<<------------------<<<
        let tracks = event.stream.getAudioTracks();
            for(let track of tracks) {
                event.stream.removeTrack(track);
            }
    }

    if(!isLocal && hostId == event.userid) { //is the host's stream
        if(event.stream.getVideoTracks().length > 0) {

        } else {
            this.muteSelf('video');
            this.settings.setAudioOnly(true);
        }

        if(event.stream.getAudioTracks().length > 0) {

        } else {
            this.muteSelf('audio');
        }
    }
  }


  newFullscreen = () => {
    let primary = document.getElementById('v1_16').getElementsByClassName('media-container')[0];
    let fs = document.getElementById('newfullscreen');
    let vid = primary.getElementsByTagName('video')[0];
    let height = 300;
    let width = 300;
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    let frameTicker;
    let closedTicker;
    fs.style.backgroundColor="black";
        
        let checkCanvas = () => {
            let check = fs.getElementsByTagName('canvas');
            if(check.length > 0){
                return(true)
            }
                return (false);
        }

        let create = () => {
            fs.appendChild(canvas);
            context.fillRect(0, 0, height, width);
            context.drawImage(vid, 0, 0, height, width);
            canvas.style.width = "100%";
 
        }

        let updateFrame = () => {
            let w = fs.clientWidth;
            context.fillRect(0, 0, height, width);
            context.drawImage(vid, 0, 0, height, width);
        }

        let checkWindowClosed = () =>{
            if(fs.style.display == "none"){
                canvas.parentNode.removeChild(canvas);
                clearInterval(closedTicker);
            }
        }
        
        if(!checkCanvas()) {
            create();
            frameTicker = setInterval(updateFrame, 33);
            closedTicker = setInterval(checkWindowClosed, 1000) 
        }
        

  }
  
  fullscreen = () => { //this is actually POP out full screen needs to be fixed - window size - video/canvas scale issue

    let myWindow = window.open("", "Primary", "width=800,height=800,left=-10000,titlebar=0,toolbar=0");
    let primary = document.getElementById('v1_16').getElementsByClassName('media-container')[0];
    let fullscreenContainer = document.createElement('div');
    let height = window.innerHeight;
    let width = window.innerWidth;
        myWindow.document.body.style.margin = "0";
        myWindow.document.body.style.padding = "0";
        myWindow.document.body.style.overflow = "hidden";
        myWindow.document.body.style.backgroundColor = "black";


    let mc = primary.getElementsByClassName('media-controls')[0];
    let vc = primary.getElementsByClassName('volume-control')[0];
        if(mc) { mc.remove()}
        if(vc) { vc.remove()}

        let vid = primary.getElementsByTagName('video')[0];
        let canvas = document.createElement('canvas');
        let context = canvas.getContext('2d');

            
            canvas.height = height;
            canvas.width = width;
            
            canvas.style.position = "absolute;"
            canvas.style.width = "100%";
            canvas.style.height = "100%";
            
            myWindow.document.body.style.display = "flex";
            myWindow.document.body.appendChild(canvas);

            context.fillRect(0, 0, height, width);
            context.drawImage(vid, 0, 0, height, width);

        let updateFrame = () => {
            context.fillRect(0, 0, height, width);
            context.drawImage(vid, 0, 0, height, width);
        }

        let checkWindowClosed = () =>{
            if(myWindow.closed) {
                console.log('full screen window closed')
                clearInterval(closedTicker);
            }
        }



        let frameTicker = setInterval(updateFrame, 33);
        let closedTicker = setInterval(checkWindowClosed, 1000)

  


        /*
        fullscreenContainer.appendChild(primary);
        myWindow.document.body.appendChild(fullscreenContainer);
        myWindow.document.body.style.overflow = "hidden";
        myWindow.document.body.style.margin = "0";

        fullscreenContainer.style.border = "solid red"
        fullscreenContainer.style.height = "100%";
        
        let video = myWindow.document.getElementsByTagName('video')[0];
            video.style.position = "absolute";
            video.style.width = "100%";
            video.style.height = "100%";
            video.classList.add('test4');
           // video.style.objectFit = "fill";
        */

    

        


  }



/* NOT SURE THIS SCREENSHARE IS ACTUALLY USED. THERE IS ONE IN USER-CONTROLS.COMPONENT.TS */
  screenshare = (ssId) => {
      
      let connection = this.connection.connection;
      let myId = this.settings.getId();
          this.screenshareOpenId = ssId;
          this.settings.changeLayout("ScreenShare");
          
             
     
      

      //primary is still under the ss element
      let primary = document.getElementById('v1_16');
      let frame = document.createElement('iframe');
        frame.src = "./Screenshare.html";
        frame.style.width = "100%";
        frame.style.position = "absolute";
        primary.appendChild(frame);
     


      //Tell Iframe to open screenshare
      setTimeout(()=> {
         frame.contentWindow.postMessage({type: "frameScreenshareData", screenshareId: myId}, "*") //open the screenshare for the host.
         let broadcastScreenshareId = setTimeout(()=>{
             //send ssId to other clients.
             connection.sendCustomMessage({type: "screenshareReq", msg: {requesterId: myId, screenshareId: ssId, session: this.connection.connection.sessionid}});
         }, 2000)
      }, 3000)
      
    }

    closeScreenshare = (e) => {
        let myId = this.settings.getId();
        let frame = document.getElementById('screenshareframe');
            frame.parentElement.removeChild(frame);
            this.settings.changeScreenshareOpenState(false);
            //frame.contentWindow.postMessage({type: "closeScreenshare", screenshareId: myId}, "*");
    }

  changeLayout = (layout) => {
    let videoContainer = document.getElementById('MasterVideoContainer');
    if(videoContainer) {
        videoContainer.classList.remove("grid_primary", "grid_secondary", "grid_auxiliary", "grid_two_way", "grid_four_way", "grid_screenshare");
        this.numberOfWindows = 5;
        
        switch(layout) {
            case "Secondary": {
                videoContainer.classList.add("grid_secondary")
                //this.screenshare(this.settings.getUsername());
                break;
            }
            case "Auxiliary": {
                videoContainer.classList.add("grid_auxiliary")
                break;
            }
            case "Two-Way": {
                videoContainer.classList.add("grid_two_way")
                this.numberOfWindows = 2;
                break;
            }
            case "Four-Way": {
                videoContainer.classList.add("grid_four_way")
                break;
            }
           case "ScreenShare": {
                videoContainer.classList.add("grid_screenshare")
                break;
            }
            default: {
                videoContainer.classList.add("grid_primary")
                break;
            }
        }
    }
  }

  screenshareCheck = () => {

    let ssId = this.screenshareOpenId;
    let myId = this.settings.getId();
        this.numberOfWindows = 5;

    if(this.screenshareOpen && ssId) {
        this.connection.connection.sendCustomMessage({type: "screenshareReq", msg: {requesterId: myId, screenshareId: ssId, session: this.connection.connection.sessionid}});
    }
  } 

  constructor(private settingsService: SettingsService, private connectionService: ConnectionService) {
    this.settings = settingsService;
    this.connection = connectionService;
    this.videoStreams = this.connection.streamList;

    this.settings.cast.subscribe((layout)=> {
      this.changeLayout(layout);
    });

    this.settings.screenshareOpenCast.subscribe((status)=> {
      this.screenshareOpen = status;
    });

    this.settings.audioOnlyCast.subscribe((state)=> {
        this.audioOnly = state;
    });

  }

  broadcastName = () =>{
      let name = this.settings.username;
      let id = this.connection.connection.userid;
    
      setTimeout(()=>{
        this.connection.announceName(name, id);
        console.log(`Boradcasting my name: ${name} with ID: ${id}`)
      }, 8000)
  }

  hostBroadcast = () => { 
    let isHost = this.connection.connection.isInitiator; 
    let myId = this.connection.connection.userid;  
    let primary = this.connection.streamList[0].userId;
   

    let pkg = { 
        id: myId,  
        screenshareId: "",
        primaryId: primary
    } 
    if(isHost) { 
        if(this.screenshareOpen && this.screenshareOpenId){ 
            pkg.screenshareId = this.screenshareOpenId; 
        } 
        this.connection.connection.sendCustomMessage({type: "hostBroadcast", msg: pkg}); 
    } 
  } 

  ngOnInit() {
      let connection = this.connection.connection;
      let conn = this.connection;
      let disableInputButtons = () => {};
      let showRoomURL:any = () =>  {};
     // let videoStreams = this.videoStreams; 
     let self = this;

        
  

      //let test = this.connection.streamsList.subscribe(stream=> this.videoStreams.push(stream))

       



            connection.onstream = function(event) {
                self.addUserToUsersList(event.userid, event.streamid);
                self.checkAlreadyExists(event.streamid);
                self.checkIsScreen(event.stream);
                self.checkSetup(event); //checkIsLocal called inside
                self.screenshareCheck();
                self.broadcastName();

                setTimeout(()=>{
                    self.hostBroadcast();
                },3000)


         
   
    

                var mediaElement = getMediaElement(event.mediaElement, {
                    title: event.userid,
                    buttons: ['full-screen'],
                    showOnMouseEnter: false
                });

              	self.addVideo(event, mediaElement);
                
                
                setTimeout(function() {
                    mediaElement.media.play();
                    
                }, 5000);
                mediaElement.id = event.streamid + 999;
            };
            
            connection.onstreamended = function(event) {
              self.removeVideo(event.streamid);
              self.removeUserFromUserList(event.streamid);
              conn.updateVideoStreams();
              //self.removeFromUserList(event);
            };
        
            connection.onmute = function (e) { 
                e.mediaElement.setAttribute('poster', "./Scripts/esdn/assets/images/personicon2.jpg");
            };

            

            
            
  }

}
